export enum IdSides {
    FRONT = "front",
    BACK = "back"
}